import * as styles from "./dotBadge.module.scss";

export interface DotBadgeProps {
	testId?: string;
}
export const DotBadge = ({ testId }: DotBadgeProps) => <span className={styles.badge} data-testid={testId}></span>;
